import { useState } from 'react';
import { iniciarSesion } from '../auth/msal';
import { LogoLogin, LogoPie } from '../componentes/Marca';

export function PantallaLogin() {
  const [entrando, setEntrando] = useState(false);

  return (
    <div className="relative flex min-h-full items-center justify-center px-5 py-16">
      <div className="w-full max-w-[420px] overflow-hidden rounded-2xl border border-white/10 bg-panel shadow-modal">
        <div className="h-1 bg-gradient-to-r from-verde via-azul to-panel" />

        <div className="px-8 py-9 text-center">
          <LogoLogin alto={96} className="mx-auto" />

          <h1 className="mt-7 font-titulo text-[26px] font-extrabold leading-tight text-texto">
            App Eventos
          </h1>
          <p className="mt-2.5 text-sm leading-relaxed text-tenue">
            Confirmá tu asistencia y votá las opciones de cada evento de Procom.
          </p>

          <button
            type="button"
            disabled={entrando}
            onClick={() => {
              setEntrando(true);
              void iniciarSesion().catch(() => setEntrando(false));
            }}
            className="mt-8 flex w-full items-center justify-center gap-2.5 rounded-[10px] bg-lima px-5 py-3
                       font-titulo text-[14.5px] font-bold text-tinta transition-colors
                       hover:bg-lima-claro disabled:cursor-default disabled:opacity-60"
          >
            {entrando ? 'Redirigiendo…' : 'Iniciar sesión con Microsoft'}
          </button>

          <p className="mt-5 text-xs leading-relaxed text-mudo">
            Se usa tu cuenta corporativa de Procom. No hace falta crear ninguna contraseña nueva.
          </p>
        </div>
      </div>

      <div className="pointer-events-none absolute bottom-6 left-6 hidden opacity-70 sm:block">
        <LogoPie alto={15} />
      </div>
    </div>
  );
}
